import { useTranslation } from "@coworker/locales";
import { Text } from "../Atoms/Text";
import { MediasAndArticleCountResponse } from "../types/media";
import { getMediaName, getPiecesTranslation } from "../tools";

interface PlacementsTextProps {
  currentArticleId: string;
  mediasArticleCount: MediasAndArticleCountResponse[];
}

export function PlacementsText({
  currentArticleId,
  mediasArticleCount,
}: PlacementsTextProps) {
  const { t } = useTranslation();
  // Group by media ID and sum articles
  const groupedMedias = mediasArticleCount.reduce(
    (acc, media) => {
      const key = `${media.parentMediaName}-${media.name}`;
      if (!acc[key]) {
        acc[key] = {
          ...media,
          nbrArticles: 0,
          isSelected: false,
        };
      }
      acc[key].nbrArticles += media.nbrArticles;
      if (media.articleId === currentArticleId) {
        acc[key].isSelected = true;
      }
      return acc;
    },
    {} as Record<
      string,
      (typeof mediasArticleCount)[0] & { isSelected: boolean }
    >
  );

  return (
    <>
      <>
        {Object.values(groupedMedias).map((media) => {
          const piecesOrPiece = t(getPiecesTranslation(media.nbrArticles));
          return media.isSelected ? (
            <Text
              key={`selected-${media.articleId}`}
              text={`${getMediaName(media.parentMediaName, media.name)}: ${media.nbrArticles} ${piecesOrPiece} ${t(
                "selectedString"
              )}`}
              bold
              grey
            />
          ) : (
            <Text
              key={media.articleId}
              text={`${getMediaName(media.parentMediaName, media.name)}: ${media.nbrArticles} ${piecesOrPiece}`}
              grey
            />
          );
        })}
      </>
    </>
  );
}
